import { BaseViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { FacilityService } from 'application/facility/services';
import { action } from 'mobx';
@applicationContext
class FacilityMissingDocsSearchViewStore extends BaseViewStore {
    constructor(rootStore) {
        super(rootStore);

        const service = new FacilityService(rootStore.application.baasic.apiClient);
        this.facilityStore = new BaasicDropdownStore({
            filterable: true,
        }, {
            fetchFunc: async (term) => {
                const response = await service.find({ searchQuery: term, rpp: 50 });
                return response.data.item;
            },
            onClose: () => {
                var facility = this.facilityStore.items.find(x => x.name === this.facilityName);
                if (this.facilityName && facility) {
                    return this.rootStore.routerStore.goTo('master.app.main.facility-missing-docs.preview',{ id: facility.id, showOnlyPastTemplates: 'false' });
                }
            }
        });
        this.fetch([() => { }]);
    }

    @action.bound
    setFacilityName(value) {
        this.facilityName = value;
    }
}

export default FacilityMissingDocsSearchViewStore;
